import { saveEventOnAnalytics } from '../../../../../../utils/helpers'

class NfeList {
    static get $inject() {
        return ['gql', '$scope', '$uibModal', 'downloadService', 'Etiquetas', 'Nfes', 'EfSocket', 'UsuariosService']
    }

    constructor(gql, scope, modal, downloadService, Etiquetas, Nfes, EfSocket, UsuariosService) {
        this.gql = gql
        this.scope = scope
        this.modal = modal
        this.downloadService = downloadService
        this.tabsController = scope.$parent.tabController
        this.Etiquetas = Etiquetas
        this.Nfes = Nfes
        this.EfSocket = EfSocket
        this.UsuariosService = UsuariosService

        this.apply = (fn) => scope.$apply(fn)
        this.emit = (event, payload) => scope.$emit(event, payload)

        this.order = { sortField: 'EMISSAO', sortOrder: 'DESC' }
        this.filter = {}
        this.perPage = 25

        this.nfesSelecionadas = []

        this.limiteXmlZip = 2000
        this.limiteDaZip = 25
        this.limiteImpressaoPDF = 600

        this.receitaUrl = 'http://www.nfe.fazenda.gov.br/portal/consultaRecaptcha.aspx?tipoConsulta=completa&tipoConteudo=XbSeqxE8pl8='

        scope.$watch(() => this.loteEtiquetas, loteEtiquetas => {
            if (loteEtiquetas) {
                const nfesSelecionadasIds = new Set(this.nfesSelecionadas)
                const nfesSelecionadas = this.nfes.filter(nfe => nfesSelecionadasIds.has(nfe.id))

                this.Etiquetas
                    .etiquetasOfNfesBasedOnLote(nfesSelecionadas, this.loteEtiquetas)
                    .forEach(({ nfeId, etiquetas }) => {
                        const nfe = nfesSelecionadas.find(nfe => nfe.id == nfeId)
                        if (nfe) nfe.etiquetas = etiquetas
                    })
            }
        })
    }

    $onInit() {
        this.channel = `nfes:${this.contratoId}`
        this.manifestoSubscription = this.subscribeToManifestacao(this.contratoId)
        this.etiquetasSubscription = this.subscribeToEtiquetas(this.contratoId)
    }

    $onDestroy() {
        this.manifestoSubscription()
        this.etiquetasSubscription()
    }

    $onChanges({ filter }) {
        if (filter) {
            if (filter.currentValue) {
                this.currentPage = 1
                this.filter = filter.currentValue
                this.loadingPromise = this.loadNfes({})
            } else {
                this.nfes = null
            }
        }
    }

    subscribeToManifestacao(empresaId) {
        const subscription = `
            subscription($empresaId: String!) {
                manifesto: nfeManifestada(empresaId: $empresaId) {
                    nfe {
                        id
                    }
                    evento
                }
            }
        `

        const onNfeManifestada = ({ data: { manifesto } }) => {
            const { nfe: { id: nfeId }, evento } = manifesto

            this.apply(() => {
                this.nfes = this.nfes.map((nfe) => {
                    if (nfe.id === nfeId) {
                        nfe.tiposManifestos = nfe.tiposManifestos || []
                        nfe.tiposManifestos.push(evento)
                    }

                    return nfe
                })
            })
        }

        return this.gql
            .subscribe(subscription, { empresaId: empresaId.toString() }, onNfeManifestada)
    }

    subscribeToEtiquetas(empresaId) {
        const etiquetaFields = `
            id
            nfe { id }
            etiqueta {
                id
                nome
                descricao
                cor
            }
        `
        const nfeEtiquetasAdicionadas = `
            subscription($empresaId: String!) {
                etiquetas: nfeEtiquetasAdicionadas(empresaId: $empresaId) {
                    ${etiquetaFields}
                }
            }
        `

        const nfeEtiquetasRemovidas = `
            subscription($empresaId: String!) {
                etiquetas: nfeEtiquetasRemovidas(empresaId: $empresaId) {
                    ${etiquetaFields}
                }
            }
        `

        const onEtiquetasAdicionadas = ({ data: { etiquetas } }) => {
            const etiquetasByNfeId = etiquetas.groupBy(e => e.nfe.id, e => e.etiqueta)

            this.nfes
                .filter(nfe => etiquetasByNfeId[nfe.id])
                .forEach(nfe => {
                    const etiquetas = [...nfe.etiquetas, ...etiquetasByNfeId[nfe.id]]
                        .uniqBy(e => e.id)

                    nfe.etiquetas = etiquetas
                    nfe.previousEtiquetas = etiquetas
                })

            this.apply()
        }

        const onEtiquetasRemovidas = ({ data: { etiquetas } }) => {
            const etiquetasIdsByNfeId = etiquetas.groupBy(e => e.nfe.id, e => e.etiqueta.id)

            this.nfes
                .filter(nfe => etiquetasIdsByNfeId[nfe.id])
                .forEach(nfe => {
                    const etiquetasToRemove = new Set(etiquetasIdsByNfeId[nfe.id])
                    const etiquetas = nfe.etiquetas.reject(e => etiquetasToRemove.has(e.id))

                    nfe.etiquetas = etiquetas
                    nfe.previousEtiquetas = etiquetas
                })

            this.apply()
        }

        const adicionadasSubscriptions = this.gql
            .subscribe(nfeEtiquetasAdicionadas, { empresaId: empresaId.toString() }, onEtiquetasAdicionadas)

        const removidasSubscriptions = this.gql
            .subscribe(nfeEtiquetasRemovidas, { empresaId: empresaId.toString() }, onEtiquetasRemovidas)

        return () => {
            adicionadasSubscriptions()
            removidasSubscriptions()
        }
    }

    pageChange(page) {
        this.loadingPromise = this.loadNfes(page)
    }

    get allChecked() {
        return this.nfes && this.nfes
            .filter(nfe => nfe.possuiXml)
            .every((nfe) => this.nfesSelecionadas.includes(nfe.id))
    }

    checkAll() {
        if (this.allChecked)
            this.nfesSelecionadas = this.nfesSelecionadas.reject((nfeId) => this.nfes.find((nfe) => nfe.id === nfeId))
        else {
            const unchecked = this.nfes
                .filter((nfe) => nfe.possuiXml)
                .map((nfe) => nfe.id)
                .reject((nfeId) => this.nfesSelecionadas.includes(nfeId))

            this.nfesSelecionadas.push(...unchecked)
        }
    }

    uncheckAll() {
        this.nfesSelecionadas = []
    }

    popoverChave(chave) {
        return `<input type='text' value='${chave}'>`
    }

    openDetails(nfe) {
        this.onOpenDetails({ nfe: nfe })
    }

    listarCtes(nfe) {
        this.onListCtes({ nfe: nfe })
    }

    openManifestoModal(nfe) {
        this.modal
            .open({
                backdrop: 'static',
                component: 'nfeManifestoModal',
                resolve: {
                    empresaId: () => this.contratoId,
                    nfesIds: () => nfe ? [nfe.id] : this.nfesSelecionadas
                }
            })
            .result.then(() => this.nfesSelecionadas = [])
    }

    informarFrete(nfe) {
        this.modal.open({
            backdrop: 'static',
            component: 'nfeFreteManualModal',
            resolve: {
                nfe: nfe,
                channel: () => this.channel
            }
        }).result.then(() => {
            nfe.fretePendente = false
        })
    }

    informarRetornoGarantia(nfe) {
        Confirm.warning(
            'Atenção',
            `Deseja realmente ${nfe.retornoGarantia ? 'desmarcar' : 'marcar'} a NF-e n° ${nfe.numero} como retorno em garantia?`,
            {
                'Não': angular.noop,
                'Sim': () => {
                    this._socket()
                        .push(this.channel, "marcar_retorno_garantia", { nfe: nfe.id, retorno_garantia: !nfe.retornoGarantia })
                        .then(() => {
                            this.apply(nfe.retornoGarantia = !nfe.retornoGarantia)

                            Alert.success(`A NF-e #${nfe.numero} foi ${nfe.retornoGarantia ? 'desmarcada' : 'marcada'} como retorno em garantia!`, 'Sucesso')
                        })
                        .catch(() =>
                            Alert.error(`Ocorreu um erro ao ${nfe.retornoGarantia ? 'desmarcar' : 'marcar'} a NF-e n° ${nfe.numero} como retorno em garantia.`, 'Erro!', false)
                        )
                }
            }
        )
    }

    possivelRetornoEmGarantia(nfe) {
        return !nfe.retornoGarantia && ((nfe.informacoesComplementares || "").search(/garantia/i) >= 0)
    }

    abrirConsultaPortal() {
        const width = window.outerWidth * 0.7
        const height = width * window.outerHeight / window.outerWidth;

        const top = (window.outerHeight - height) / 2
        const left = (window.outerWidth - width) / 2

        window.open(this.receitaUrl, 'newwindow', `width=${width},height=${height},top=${top},left=${left}`)
    }

    downloadNfeXml(nfe) {
        saveEventOnAnalytics('Operações com XML', 'Download NF-e XML', `Empresa: ${this.contratoId}`)

        this.downloadOperation(this.fetchTokenNfe('DownloadNfeXml', nfe.chave, 'xml'))
    }

    downloadDanfe(nfe) {
        saveEventOnAnalytics('Operações com XML', 'Download NF-e DANFE', `Empresa: ${this.contratoId}`)

        this.downloadOperation(this.fetchTokenNfe('DownloadNfeDa', nfe.chave, 'danfe'))
    }

    downloadOperation(tokenPromise) {
        tokenPromise
            .then(token => this.downloadService.download(`/resume-operation/${token}`))
            .catch(console.error)
    }

    async fetchTokenNfe(operation, chave, format) {
        const query = gql`
            query ${operation}($empresaId: Int!, $filter: NfeFilter!) {
                contrato: empresa(id: $empresaId) {
                    id
                    nfesPage(filter: $filter) {
                        nfes: entries {
                            ... on Nfe {
                                ${format} { token }
                            }
                        }
                    }
                }
            }
        `

        let { contrato: { nfesPage: { nfes: [nfe] } } } =
            await this.gql.query(query, { empresaId: parseInt(this.contratoId), filter: { chave } })

        return nfe[format]['token']
    }

    downloadXlsx() {
        this.Nfes.downloadXlsx(this.contratoId, this.filter, this.nfesSelecionadas)
    }

    downloadPdf() {
        const query = this.buildOperationQuery('DownloadNfesPdf', 'nfesPdf', this.limiteImpressaoPDF)

        this.downloadPromise = this.paginatedDownloadOperation(query)
    }

    downloadXmlZip() {
        saveEventOnAnalytics('Operações com XML', 'Download NF-e XML ZIP', `Empresa: ${this.contratoId}`)

        const query = this.buildOperationQuery('DownloadNfesXmlZip', 'nfesXmlZip', this.limiteXmlZip)

        this.downloadPromise = this.paginatedDownloadOperation(query)
    }

    downloadDaZip() {
        saveEventOnAnalytics('Operações com XML', 'Download NF-e DANFE ZIP', `Empresa: ${this.contratoId}`)

        const query = this.buildOperationQuery('DownloadNfesDaZip', 'nfesDaZip', this.limiteDaZip)

        this.downloadPromise = this.paginatedDownloadOperation(query)
    }

    buildOperationQuery(operation, type, limit) {
        return gql`
            query ${operation}($empresaId: Int!, $filter: NfeFilter!, $order: NfeOrder!, $next: String) {
                contrato: empresa(id: $empresaId) {
                    id
                    operation: ${type}(filter: $filter, order: $order, next: $next, limit: ${limit}) {
                        token
                        next
                    }
                }
            }
        `
    }

    paginatedDownloadOperation(query, filter = null, order = null, nextPage = null, yesForAll = false) {
        if (!filter) {
            if (this.nfesSelecionadas.length > 0)
                filter = { ids: this.nfesSelecionadas, order: this.filter.order }
            else
                filter = angular.copy(this.filter)
        }

        if (!order)
            order = angular.copy(filter.order)

        delete filter.order

        return this.gql
            .query(query, { empresaId: this.contratoId, next: nextPage, filter, order })
            .then(({ contrato: { operation } }) => operation)
            .then(({ token, next }) => {
                return this.downloadService
                    .download(`/resume-operation/${token}`)
                    .then(() => {
                        if (next) {
                            if (yesForAll)
                                return this.paginatedDownloadOperation(query, filter, order, next, true)
                            else {
                                let options = {
                                    "Não": angular.noop,
                                    "Sim": () => this.paginatedDownloadOperation(query, filter, order, next)
                                }

                                if ((filter.emissaoInicial && filter.emissaoFinal) || filter.emitente || filter.destinatario) {
                                    options = {
                                        ...options,
                                        "Sim para todos": () => this.paginatedDownloadOperation(query, filter, order, next, true)
                                    }
                                }

                                return Confirm.info(
                                    "Download parcial",
                                    "Devido ao limite da operação solicitada, " +
                                    "não foi possível incluir todos os resultados. " +
                                    "Deseja realizar o download do próximo lote?",
                                    options
                                )
                            }
                        }
                    })
            })
    }

    loadNfes(page = {}) {
        const { order, ...filter } = angular.copy(this.filter)

        return this.searchNfes({ empresaId: parseInt(this.contratoId), order, filter, ...page })
            .then(({ empresa: { nfesPage: { after, before, nfes } } }) => {
                this.apply(() => {
                    const filterHasChanged = !page.after && !page.before

                    nfes = nfes.map(nfe => ({ ...nfe, previousEtiquetas: nfe.etiquetas }))

                    if (this.paginationEnabled || !this.nfes) {
                        this.nfes = nfes
                    } else {
                        this.nfes = this.nfes && !filterHasChanged ? [...this.nfes, ...nfes].uniqBy(n => n.id) : nfes
                    }
                    
                    this.nextPage = after
                    this.previousPage = before
                    this.currentPage = page.after ? this.currentPage + 1 : page.before ? this.currentPage - 1 : 1

                    if (filterHasChanged) this.searchContext = new Date()
                })
            })
    }

    async searchNfes(variables) {
        const query = gql`
            query Nfes($empresaId: Int!, $order: NfeOrder!, $filter: NfeFilter!, $after: String, $before: String) {
                empresa(id: $empresaId) {
                    id
                    nfesPage: nfes(order: $order, filter: $filter, after: $after, before: $before, size: ${this.perPage}) {
                        after
                        before
                        nfes: entries {
                            ... on Nfe {
                                id
                                numero
                                chave
                                emissao
                                status
                                modelo
                                valor
                                tipo
                                valorFrete
                                valorFreteManual
                                valorFreteIcms
                                retornoGarantia
                                tiposManifestos
                                fretePendente
                                informacoesComplementares
                                possuiXml
                                frete {
                                    hasFreteCte
                                    freteCte {
                                        valorBaseCalculo
                                        valorIcms
                                        hasRateioFrete
                                    }
                                    freteManual {
                                        valorBaseCalculo
                                        valorIcms
                                    }
                                }
                                filial {
                                    id
                                }
                                emitente { 
                                    id
                                    nome
                                    cpfCnpj
                                    municipio
                                    uf 
                                }
                                destinatario {
                                    id
                                    nome
                                    cpfCnpj
                                    municipio
                                    uf 
                                }
                                ctes {
                                    id
                                    numero
                                    chave
                                }
                                etiquetas {
                                    id
                                    nome
                                    descricao
                                    cor
                                }
                            }
                        }
                    }
                }
            }
        `

        return await this.gql.query(query, variables)
    }

    selectEtiqueta(etiqueta) {
        this.emit('filterByEtiqueta', etiqueta)
    }

    onEtiquetasClose(nfe) {
        nfe.etiquetasPromise = this.Etiquetas
            .setNfeEtiquetas(this.contratoId, nfe, nfe.etiquetas)
            .then(etiquetas => {
                nfe.etiquetas = etiquetas
                nfe.previousEtiquetas = etiquetas
            })
            .catch(() => {
                nfe.etiquetas = nfe.previousEtiquetas
            })
            .finally(() => this.apply())

        nfe.showEtiquetas = false
    }

    openLoteEtiquetas() {
        const nfesSelecionadas = this.nfes.filter(nfe => this.nfesSelecionadas.includes(nfe.id))

        this.loteEtiquetas = this.Etiquetas.etiquetasInCommonOnNfes(nfesSelecionadas)

        this.isLoteEtiquetasOpen = true
    }

    onLoteEtiquetasClosed() {
        const nfesSelecionadas = this.nfes
            .filter(nfe => this.nfesSelecionadas.includes(nfe.id))

        this.loteEtiquetasPromise = this.Etiquetas
            .setLoteNfesEtiquetas(this.contratoId, nfesSelecionadas, this.loteEtiquetas)
            .then(() =>
                nfesSelecionadas.forEach(nfe => nfe.previousEtiquetas = nfe.etiquetas)
            )
            .catch(() =>
                nfesSelecionadas.forEach(nfe => nfe.etiquetas = nfe.previousEtiquetas)
            )
            .finally(() => this.apply())

        this.isLoteEtiquetasOpen = false;
    }

    loadingMore() {
        this.loadingMoreNfePromise = this.loadNfes({after: this.nextPage})
    }

    get paginationEnabled() {
        if (this._paginationEnabled != undefined) {
            return this._paginationEnabled
        }

        const storedPaginationEnabled = localStorage.getItem('ef-nfes-pagination-enabled')

        return this._paginationEnabled = storedPaginationEnabled ? JSON.parse(storedPaginationEnabled) : true
    }

    set paginationEnabled(enabled) {
        localStorage.setItem('ef-nfes-pagination-enabled', JSON.stringify(enabled))
        
        this._paginationEnabled = enabled
        this.searchContext = new Date() 

        this.nfes = []

        this.loadingPromise = this.loadNfes({})
    }
    
    _socket() {
        return this.EfSocket.socket(this.UsuariosService.token)
    }
}

angular.module('eficienciaFiscalModule')
    .component('nfeList', {
        controller: NfeList,
        bindings: {
            filter: '<',
            contratoId: '<',
            tipoEmissao: '@',
            onListCtes: '&',
            onOpenDetails: '&'
        },
        //language=HTML
        template: `
        <loading promise="$ctrl.loadingPromise">
            <div>
                <highlighted ng-show="$ctrl.nfes.length === 0">
                    <main>Nenhuma informação encontrada.</main>
                </highlighted>

                <highlighted ng-show="$ctrl.nfes == undefined">
                    <main>Preencha o filtro acima para realizar uma consulta.</main>
                </highlighted>

                <div ng-if="$ctrl.nfes.length > 0">
                    <div style="margin: 0 0 9px;">
                        <div style="display: flex; align-items: center; justify-content: flex-end;">
                            Operações em lote: 
                            <div class="operacoes-em-lote">
                                <div ng-if="$ctrl.tipoEmissao == 'TERCEIROS'" tooltip="Esta operação será dividida em lotes de 20 NF-e.">
                                    <button
                                        style="text-decoration: underline; color: #3276b1; padding-right: 0"
                                        class="btn btn-xs btn-link"
                                        ng-click="$ctrl.openManifestoModal()"
                                        ng-disabled="$ctrl.nfesSelecionadas.length == 0">
                                        Manifesto do destinatário 
                                    </button>
                                </div>

                                <promise-tracker promise="$ctrl.loteEtiquetasPromise", active="isLoading">
                                    <button
                                        style="text-decoration: underline; color: #3276b1"
                                        class="btn btn-xs btn-link"
                                        ng-click="$ctrl.openLoteEtiquetas()"
                                        ng-disabled="$ctrl.nfesSelecionadas.length == 0 || isLoading">
                                        Etiquetas
                                        <span ng-show="isLoading">
                                            <i class="fa fa-spinner fa-spin"></i>
                                        </span>
                                    </button>

                                    <ef-etiquetas-popover 
                                        ng-if="$ctrl.isLoteEtiquetasOpen" 
                                        ng-model="$ctrl.loteEtiquetas" 
                                        empresa-id="$ctrl.contratoId"
                                        on-close="$ctrl.onLoteEtiquetasClosed()"
                                        position="end">
                                    </ef-etiquetas-popover>
                                </promise-tracker>
                            </div>
                        </div>
                    </div>

                    <nfe-downloads
                        promise="$ctrl.downloadPromise"
                        nfes-selecionadas="$ctrl.nfesSelecionadas.length"
                        xlsx="$ctrl.downloadXlsx()"
                        pdf="$ctrl.downloadPdf()"
                        zip-xml="$ctrl.downloadXmlZip()"
                        zip-da="$ctrl.downloadDaZip()"
                        limites="{'zipXml': $ctrl.limiteXmlZip, 'zipDa': $ctrl.limiteDaZip, 'pdf': $ctrl.limiteImpressaoPDF}">
                    </nfe-downloads>

                    <div style="position: relative; min-height: 32px;">
                        <div class="smart-form" style="position: absolute; margin-bottom: 8px;">
                            <label class="checkbox">
                                <input 
                                    type="checkbox" 
                                    ng-click="$ctrl.paginationEnabled = !$ctrl.paginationEnabled" 
                                    ng-checked="$ctrl.paginationEnabled" 
                                    name="checkbox-inline">
                                <i></i>
                                Habilitar paginação
                            </label>
                        </div>
                        <cursor-paginator ng-if="$ctrl.paginationEnabled" per-page="$ctrl.perPage" next-page="$ctrl.nextPage" previous-page="$ctrl.previousPage"
                            current-page="$ctrl.currentPage" current-page-size="$ctrl.nfes.length" 
                            on-change="$ctrl.pageChange($page)" search-context="$ctrl.searchContext">
                        </cursor-paginator>
                    </div>

                    <script type="text/ng-template" id="popover-chave">
                        <div class="input-group">
                            <input
                                type="text"
                                class="form-control"
                                style="background-color: white; cursor: text"
                                value="{{$context.chave}}"
                                readonly>
                            <span class="input-group-btn">
                                <button class="btn btn-default" type="button" title="Copiar" data-toggle="tooltip" 
                                        ng-click-copy="{{$context.chave}}">
                                    <i class="fa fa-copy"></i>
                                </button>
                            </span>
                        </div>
                    </script>

                    <table class="table no-margin">
                        <thead>
                            <tr>
                            <th class="text-center" width="1">#</th>
                            <th class="text-center" width="1">
                                <div class="smart-form" style="width: 20px; margin-top: -20px; display: flex; align-items: baseline;">
                                    <label class="checkbox" tooltip="Ao clicar nesta opção, apenas as NF-e que contém XML serão selecionadas 
                                        na listagem." tooltip-placement="top">
                                        <input type="checkbox" ng-click="$ctrl.checkAll()" ng-checked="$ctrl.allChecked" 
                                                name="checkbox-inline">
                                        <i></i>
                                    </label>
                                    <i class="fa fa-trash-o cursor-pointer text-danger" ng-click="$ctrl.uncheckAll()" 
                                        ng-show="$ctrl.nfesSelecionadas && $ctrl.nfesSelecionadas.length"
                                        tooltip="Limpar toda a seleção"></i>
                                </div>
                            </th>
                            <th ng-if="$ctrl.tipoEmissao == 'TERCEIROS'" class="text-center" width="1"><span tooltip="Manifestos realizados">Manifesto</span></th>
                            <th>Dados da emissão</th>
                            <th>Dados do emitente</th>
                            <th>Dados do destinatário</th>
                            <th class="text-center no-break" width="1">
                                <span tooltip="Status da NF-e">Status</span>
                            </th>
                            <th ng-if="$ctrl.tipoEmissao == 'PROPRIA'" class="visible-lg text-center">Modelo</th>
                            <th class="text-center" width="1"></th>
                            <th class="text-right">Valor</th>
                            <th width="1">Opções</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr ng-repeat-start="nfe in $ctrl.nfes track by nfe.id">
                                <td rowspan="2" class="text-center-middle" ng-if="$ctrl.paginationEnabled">
                                    {{ $index + 1 + (($ctrl.currentPage - 1) * $ctrl.perPage) }}
                                </td>
                                <td rowspan="2" class="text-center-middle" ng-if="!$ctrl.paginationEnabled">
                                    {{ $index + 1 }}
                                </td>
                                <td rowspan="2" class="text-center-middle">
                                    <div class="smart-form" style="margin-top: -3px;" ng-if="nfe.possuiXml">
                                        <label class="checkbox">
                                            <input type="checkbox" id="checkbox-nfe-{{nfe.id}}" name="checkbox-inline"
                                                    checklist-model="$ctrl.nfesSelecionadas" checklist-value="nfe.id">
                                            <i></i>
                                        </label>
                                    </div>                                    
                                </td>
                                <td rowspan="2" ng-if="$ctrl.tipoEmissao == 'TERCEIROS'" class="text-center-middle" style="line-height: 8pt;">
                                    <i class="fa fa-circle green" style="font-size: 8pt" tooltip="Confirmação da operação"
                                        ng-show="nfe.tiposManifestos.includes('CONFIRMACAO')"></i>
                                    <i class="fa fa-circle gray" style="font-size: 8pt" tooltip="Confirmação da operação" 
                                        ng-hide="nfe.tiposManifestos.includes('CONFIRMACAO')"></i>
                                    <br/>
                                    <i class="fa fa-circle amber" style="font-size: 8pt" tooltip="Desconhecimento da operação"
                                        ng-show="nfe.tiposManifestos.includes('DESCONHECIMENTO')"></i>
                                    <i class="fa fa-circle gray" style="font-size: 8pt" tooltip="Desconhecimento da operação" 
                                        ng-hide="nfe.tiposManifestos.includes('DESCONHECIMENTO')"></i>
                                    <br/>

                                    <i class="fa fa-circle red" style="font-size: 8pt" tooltip="Operação não realizada"
                                        ng-show="nfe.tiposManifestos.includes('NAO_REALIZADO')"></i>
                                    <i class="fa fa-circle gray" style="font-size: 8pt" tooltip="Operação não realizada" 
                                        ng-hide="nfe.tiposManifestos.includes('NAO_REALIZADO')"></i>
                                    <br/>
                                </td>
                                <td class="text-middle">
                                    N° {{::nfe.numero}} <br/>
                                    <i class="popover-auto popover-md">
                                        <a href="javascript:void(0)" popover-template="popover-chave" 
                                            popover-context="{chave: nfe.chave, id: nfe.id}">Ver chave</a>
                                    </i><br/>
                                    <small>
                                        Tipo: {{::nfe.tipo != '' && nfe.tipo == '0' ? 'Entrada' : (nfe.tipo == '1' ? 'Saída' : '---')}}
                                    </small><br/>
                                    <small class="no-break">{{::nfe.emissao | date: 'medium'}}</small><br/>
                                </td>
                                <td class="text-middle">
                                    {{::nfe.emitente.nome}}<br>
                                    <small>
                                        {{::nfe.emitente.cpfCnpj.length == 14 ? 'CNPJ' : 'CPF'}}: 
                                        {{::nfe.emitente.cpfCnpj | cpfCnpj}}
                                    </small><br/>
                                    <small class="no-break">{{::nfe.emitente.municipio ? nfe.emitente.municipio + '/' : ''}}{{::nfe.emitente.uf}}</small><br/>
                                </td>
                                <td class="text-middle">
                                    <div ng-show="nfe.possuiXml && !nfe.destinatario">CONSUMIDOR FINAL</div>
                                    <div ng-show="nfe.destinatario">
                                        {{::nfe.destinatario.nome}}<br/>
                                        <small>
                                            {{::nfe.destinatario.cpfCnpj.length == 14 ? 'CNPJ' : 'CPF'}}:
                                            {{::nfe.destinatario.cpfCnpj | cpfCnpj}}
                                        </small><br/>
                                        <small class="no-break">{{::nfe.destinatario.municipio ? nfe.destinatario.municipio + '/' : ''}}{{::nfe.destinatario.uf}}</small><br/>
                                    </div>
                                </td>
                                <td class="text-center-middle">
                                    <i class="fa fa-check fa-2x text-success" ng-if="nfe.status == 'autorizada'" tooltip="Autorizado o uso da NF-e"></i>
                                    <i class="fa fa-times fa-2x text-danger" ng-if="nfe.status == 'cancelada'" tooltip="NF-e cancelada"></i>
                                </td>
                                <td ng-if="$ctrl.tipoEmissao == 'PROPRIA'" class="visible-lg text-center-middle no-break">
                                    <span ng-show="nfe.modelo">{{::nfe.modelo == 'nfe' ? 'NF-e' : 'NFC-e'}}</span>
                                    <span ng-hide="nfe.modelo">--</span>
                                </td>
                                <td class="text-center-middle">
                                    <div ng-if="$ctrl.tipoEmissao == 'TERCEIROS'">
                                        <a ng-if="nfe.retornoGarantia">
                                            <i class="fa fa-recycle text-success"
                                                tooltip="Esta NF-e foi marcada como retorno em garantia.">
                                            </i> <br/>
                                        </a>
                                        <a ng-if="$ctrl.possivelRetornoEmGarantia(nfe)" href="javascript:void(0)" ng-click="$ctrl.openDetails(nfe)">
                                            <i class="fa fa-recycle text-warning"
                                                tooltip="Por favor, clique aqui para visualizar os detalhes desta NF-e e 
                                                verificar se a mesma é de remessa de garantia.">
                                            </i> <br/>
                                        </a>
                                        <a ng-if="nfe.fretePendente" href="javascript:void(0)" ng-click="$ctrl.informarFrete(nfe)">
                                            <i class="fa fa-warning text-danger"
                                                tooltip="Esta NF-e não possui frete. Por favor, clique aqui para informá-lo.">
                                            </i>
                                        </a>
                                    </div>
                                    <a ng-if="nfe.ctes.length > 0" href="javascript:void(0)" ng-click="$ctrl.listarCtes(nfe)">
                                        <i class="fa fa-info-circle text-primary"
                                            tooltip="Esta NF-e possui CT-e(s) vinculado(s). 
                                            Clique aqui para visualizá-lo(s) na tela de Consulta CT-e.">
                                        </i> <br/>
                                        </a>
                                        <br/>
                                    <i ng-if="nfe.frete.freteCte.hasRateioFrete" href="javascript:void(0)" ng-click="$ctrl.listarCtes(nfe)"
                                        class="fa fa-warning text-warning"
                                        tooltip="Esta NF-e possui rateio do frete. Clique aqui para visualizar os CT-e.">
                                    </i> 
                                </td>
                                <td class="text-right text-middle no-break">
                                    {{::nfe.valor ? (nfe.valor | currency) : '-'}}
                                    <small>
                                        <br/>
                                        Frete: {{ (nfe.valorFrete > 0 ? nfe.valorFrete : (nfe.valorFreteManual || 0)) | currency}}
                                    </small>
                                    <small ng-show="nfe.valorFrete > 0 && nfe.valorFreteManual > 0">
                                        <br/>
                                        Redespacho: {{ nfe.valorFreteManual | currency }}
                                    </small>
                                </td>
                                <td rowspan="2" class="text-middle" ng-show="nfe.possuiXml">                                    
                                    <div ng-if="$ctrl.tipoEmissao == 'TERCEIROS'" class="btn-group">
                                        <a class="no-break" data-toggle="dropdown" href="javascript:void(0)">
                                            Operações <span class="caret"></span>
                                        </a>
                                        <ul class="dropdown-menu" style="right: 0; left: unset">
                                            <li>
                                                <a href="javascript:void(0)" class="cursor-pointer" ng-click="$ctrl.openManifestoModal(nfe)">
                                                    <i class="fa fa-crosshairs"></i> Manifesto do destinatário
                                                </a>
                                            </li>
                                            <li>
                                                <a ng-if="!nfe.frete.hasFreteCte" href="javascript:void(0)" class="cursor-pointer" ng-click="$ctrl.informarFrete(nfe)">
                                                    <i class="fa fa-money"></i> Incluir ou alterar o valor do frete
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)" class="cursor-pointer" ng-click="$ctrl.informarRetornoGarantia(nfe)">
                                                    <i class="fa fa-check-square-o"></i>
                                                    {{::nfe.retorno_garantia ? 'Desmarcar' : 'Marcar'}} como retorno em garantia
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)" class="cursor-pointer" ng-click="$ctrl.abrirConsultaPortal()"
                                                    ng-click-copy="{{::nfe.chave}}">
                                                    Copiar chave e abrir o Portal da NF-e
                                                </a>
                                            </li>
                                        </ul>
                                    </div>

                                    <a ng-if="$ctrl.tipoEmissao == 'TERCEIROS'" href="javascript:void(0)" ng-click="$ctrl.openDetails(nfe)">
                                        <br/>Detalhes<br/>
                                    </a>
                                    <a href="javascript:void(0)" ng-click="$ctrl.downloadDanfe(nfe)">
                                        {{::nfe.modelo == "nfe" ? "DANFE" : "DANFCE"}}
                                    </a>
                                    <br/>
                                    <a href="javascript:void(0)" ng-click="$ctrl.downloadNfeXml(nfe)">XML</a>
                                    <br/>
                                    <promise-tracker style="position: relative" promise="nfe.etiquetasPromise" active="isActive">
                                        <span ng-show="isActive">
                                            Etiquetas
                                            <i class="fa fa-spinner fa-spin"></i>
                                        </span>

                                        <a ng-hide="isActive" href="javascript:void(0)" ng-click="nfe.showEtiquetas = true">
                                            Etiquetas
                                        </a>

                                        <ef-etiquetas-popover 
                                            ng-if="nfe.showEtiquetas" 
                                            ng-model="nfe.etiquetas" 
                                            empresa-id="$ctrl.contratoId"
                                            on-close="$ctrl.onEtiquetasClose(nfe)"
                                            position="end">
                                        </ef-etiquetas-popover>
                                    </promise-tracker>
                                </td>
                                <td rowspan="2" class="text-middle text-warning" ng-hide="nfe.possuiXml">
                                    XML não disponível.
                                </td>
                            </tr>
                            <tr ng-repeat-end>
                                <td 
                                    colspan="6" 
                                    ng-show="nfe.etiquetas.length"
                                    style="padding: 0 10px; border: none">
                                    <div style="position: relative">
                                        <ef-etiqueta 
                                            ng-repeat="etiqueta in nfe.etiquetas | orderBy:'nome'"
                                            ng-click="$ctrl.selectEtiqueta(etiqueta)"
                                            style="margin: 0 5px 8px 0; display: inline-block; cursor: pointer;" 
                                            cor="{{etiqueta.cor}}" 
                                            nome="{{etiqueta.nome}}"
                                            descricao="{{etiqueta.descricao}}">
                                        </ef-etiqueta>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <cursor-paginator ng-if="$ctrl.paginationEnabled" per-page="$ctrl.perPage" next-page="$ctrl.nextPage" previous-page="$ctrl.previousPage"
                        current-page="$ctrl.currentPage" current-page-size="$ctrl.nfes.length" 
                        on-change="$ctrl.pageChange($page)" search-context="$ctrl.searchContext">
                    </cursor-paginator>

                    <nfe-downloads
                        promise="$ctrl.downloadPromise"
                        nfes-selecionadas="$ctrl.nfesSelecionadas.length"
                        xlsx="$ctrl.downloadXlsx()"
                        pdf="$ctrl.downloadPdf()"
                        zip-xml="$ctrl.downloadXmlZip()"
                        zip-da="$ctrl.downloadDaZip()"
                        limites="{'zipXml': $ctrl.limiteXmlZip, 'zipDa': $ctrl.limiteDaZip, 'pdf': $ctrl.limiteImpressaoPDF}">
                    </nfe-downloads>

                    <promise-tracker promise="$ctrl.loadingMoreNfePromise" active="loadingMoreNfeLoading" ng-if="$ctrl.nextPage && !$ctrl.paginationEnabled">
                        <div class="text-center">
                            <button type="button" class="btn btn-default" ng-disabled="loadingMoreNfeLoading" ng-click="$ctrl.loadingMore()">
                                <span ng-hide="loadingMoreNfeLoading">
                                    Carregar mais NF-e
                                </span>
                                <span ng-show="loadingMoreNfeLoading">
                                    Carregando...
                                    <i class="fa fa-spin fa-circle-o-notch"></i>
                                </span>
                            </button>
                        </div>
                    </promise-tracker>
                </div>
            </div>
        </loading>
        `
    })
